module.exports = __webpack_public_path__ + "static/allenkim100-0c7451a0f67aee8645e9f84b32f2cef5.png";